import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {MoreThanValueValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateMoreThanValueNumber = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
  shouldLogError = true,
): string | null => {
  if (!ValidationUtils.isValidationRule<MoreThanValueValidationRule>(rule, StatisticItemValidationType.MoreThanValue)) {
    return null;
  }

  const statisticValue = statistic.value;
  const ruleValue = rule.value;
  const numberStatisticValue = Number(statisticValue);

  if (ValidationUtils.isInvalidNumberValue(statisticValue)) {
    // логируем не числовое значение
    const error = FrontendError.createParseNumberValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (numberStatisticValue <= ruleValue) {
    // логируем, что числовое значение меньше чем нужно
    const error = FrontendError.createLessThanValueError(statistic.metricDesc, statisticValue, ruleValue);

    if (shouldLogError) {
      logError(error);
    }

    return null;
  }

  return statisticValue;
};
